<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.number"
            :error-messages="numberErrors"
            :label="$t('profile.tool.number')"
            required
            @input="$v.item.number.$touch()"
            @blur="$v.item.number.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.toolHeadDef"
            :error-messages="toolHeadDefErrors"
            :label="$t('profile.tool.toolheaddef')"
            required
            @input="$v.item.toolHeadDef.$touch()"
            @blur="$v.item.toolHeadDef.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.comment"
            :error-messages="commentErrors"
            :label="$t('profile.tool.comment')"
            required
            @input="$v.item.comment.$touch()"
            @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="extrudersSelectItems"
            v-model="item.extruders"
            :items="extrudersSelectItems"
            :error-messages="extrudersErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.tool.extruder')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="heaterSelectItems"
            v-model="item.heater"
            :items="heaterSelectItems"
            :error-messages="heaterErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.tool.heater')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <strong class="ml-4" >{{ $t('global.archive') }}:</strong>
          <v-switch
                v-model="item.archive"
                :error-messages="archiveErrors"
              ></v-switch>
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'ToolForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.extrudersGetSelectItems();
      this.heaterGetSelectItems();
      this.toolHeadSubsGetSelectItems();
  },
  data() {
    return {
        number: null,
        toolHeadDef: null,
        comment: null,
        extruders: null,
        heater: null,
        toolHeadSubs: null,
        archive: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_toolextruder ||
         this.isLoading_toolheater ||
         this.isLoading_toolheadsub
       );
    },
      ...mapFields('toolextruder', {
        extrudersSelectItems: 'selectItems',
        isLoading_toolextruder : 'isLoading'
      }),
      ...mapFields('toolheater', {
        heaterSelectItems: 'selectItems',
        isLoading_toolheater : 'isLoading'
      }),
      ...mapFields('toolheadsub', {
        toolHeadSubsSelectItems: 'selectItems',
        isLoading_toolheadsub : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    numberErrors() {
      const errors = [];

      if (!this.$v.item.number.$dirty) return errors;

      has(this.violations, 'number') && errors.push(this.violations.number);

      !this.$v.item.number.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    toolHeadDefErrors() {
      const errors = [];

      if (!this.$v.item.toolHeadDef.$dirty) return errors;

      has(this.violations, 'toolHeadDef') && errors.push(this.violations.toolHeadDef);

      !this.$v.item.toolHeadDef.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);

      !this.$v.item.comment.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    extrudersErrors() {
      const errors = [];

      if (!this.$v.item.extruders.$dirty) return errors;

      has(this.violations, 'extruders') && errors.push(this.violations.extruders);


      return errors;
    },
    heaterErrors() {
      const errors = [];

      if (!this.$v.item.heater.$dirty) return errors;

      has(this.violations, 'heater') && errors.push(this.violations.heater);


      return errors;
    },
    toolHeadSubsErrors() {
      const errors = [];

      if (!this.$v.item.toolHeadSubs.$dirty) return errors;

      has(this.violations, 'toolHeadSubs') && errors.push(this.violations.toolHeadSubs);


      return errors;
    },
    archiveErrors() {
      const errors = [];
      if (!this.$v.item.archive.$dirty) return errors;
      has(this.violations, 'archive') && errors.push(this.violations.archive);
      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        extrudersGetSelectItems: 'toolextruder/fetchSelectItems'
      }),
      ...mapActions({
        heaterGetSelectItems: 'toolheater/fetchSelectItems'
      }),
      ...mapActions({
        toolHeadSubsGetSelectItems: 'toolheadsub/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      number: {
        required,
      },
      toolHeadDef: {
        required,
      },
      comment: {
        required,
      },
      extruders: {
      },
      heater: {
      },
      toolHeadSubs: {
      },
      archive: {

      },
    }
  }
};
</script>
